<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            :actions="actions"
            ref="grid"
        ></dx-grid>
        <v-dialog persistent v-model="updateRequestDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Request</v-card-title
                >
                <v-layout row class="my-2">
                    <div class="font-weight-medium width-150">Account ID:</div>
                    <div>{{ rowClicked.accountID }}</div>
                </v-layout>
                <v-layout row class="my-2">
                    <div class="font-weight-medium width-150">Name:</div>
                    <div>{{ rowClicked.name }}</div>
                </v-layout>
                <v-layout row class="my-2">
                    <div class="font-weight-medium width-150">Hebrew Name:</div>
                    <div>{{ rowClicked.nameH }}</div>
                </v-layout>
                <v-btn
                    class="mb-0"
                    color="success"
                    small
                    @click="openCallbackRequestDialog"
                    >Forward To Callback Requests</v-btn
                >
                <v-textarea
                    class="my-3"
                    hide-details
                    label="Deal"
                    v-model="rowClicked.deal"
                    ref="deal"
                    rows="2"
                    outline
                ></v-textarea>
                <v-textarea
                    class="my-3"
                    hide-details
                    label="Request Message"
                    v-model="rowClicked.requestMessage"
                    ref="requestMessage"
                    rows="2"
                    outline
                ></v-textarea>
                <v-textarea
                    class="my-3"
                    hide-details
                    label="Note"
                    v-model="rowClicked.note"
                    ref="note"
                    rows="2"
                    outline
                ></v-textarea>
                <v-autocomplete
                    class="my-3"
                    hide-details
                    label="Assigned To"
                    placeholder="Start typing..."
                    hide-no-data
                    ref="assignedTo"
                    v-model="rowClicked.assignedTo"
                    :items="users"
                    :search-input.sync="loadUsers"
                ></v-autocomplete>
                <v-select
                    v-model="rowClicked.status"
                    label="Status"
                    class="my-3"
                    :items="['PENDING', 'COMPLETED']"
                    hide-details
                ></v-select>
                <v-card-actions class="mx-0 px-2 pb-2 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateRequestDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="save()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="callbackRequestDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0">
                    Are you sure?
                </v-card-title>
                <div class="mb-3">
                    The request will be forwarded to Callback Requests and
                    marked as completed
                </div>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="callbackRequestDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="moveToCallbackRequest()"
                        >Confirm</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div></template
>
<script>
import moment from "moment";
import { formatPhoneNumber } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Discount Requests",

        rowClicked: {},
        updateRequestDialog: false,
        callbackRequestDialog: false,

        actions: [],

        url: "",
        regID: "",
        user: "",
        processing: false,

        accounts: [],
        firebaseRef: "",

        loadUsers: null,
        users: [],

        columns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value) => {
                    switch (value) {
                        case "COMPLETED":
                            return "mdi-check-circle";
                        case "PENDING":
                            return "mdi-clock";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    switch (value) {
                        case "COMPLETED":
                            return "success";
                        case "PENDING":
                            return "#fdb400";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                label: "Account ID",
                field: "accountID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "NameH",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Caller ID",
                field: "callerID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Callback Number",
                field: "callbackNumber",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Recording",
                template: "play-audio-cell-template",
                field: "recording",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                durationColumn: "recordingDuration",
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "AssignedTo",
                field: "assignedTo",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Recording Updated At",
                field: "recordingUpdatedAt",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Request Message",
                field: "requestMessage",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Reg ID",
                field: "regID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Registration Status",
                field: "registrationStatus",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Missing Requirements",
                field: "missingRequirements",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "students",
                label: "Students",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "tuitionBalance",
                label: "Tuition Balance",
                type: "number",
                format: "currency",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Flag",
                field: "flag",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student Classes",
                field: "studentClasses",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Deal",
                field: "deal",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Completed At",
                field: "completedAt",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
            },
            {
                label: "Completed By",
                field: "completedBy",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    watch: {
        async loadUsers(value) {
            if (!value) return;

            const response = await this.$http.get(
                `/odata/users?$count=true&$filter=(contains(userName, '${value.trim()}'))`,
            );

            this.users = response.value.map((u) => u.userName);
        },
    },
    created() {
        this.user = this.$store.state.authentication.user;
    },
    methods: {
        async beforeSetupGrid() {
            // this.actions.push({
            //     text: "Pickup Calls",
            //     action: this.assignCall,
            //     showOnSelection: true,
            // });

            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms,
                align: "left",
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url = "tuitionDiscountRequests?regID=" + this.regID;
        },
        async onRowClicked(row) {
            this.rowClicked = JSON.parse(JSON.stringify(row));

            const response = await this.$http.get(`/odata/users?$count=true`);

            this.users = response.value.map((u) => u.userName);

            this.updateRequestDialog = true;
        },
        async loadRegID() {
            this.regID = await this.$http.get(
                "api/tuitionDiscountRequests/getRegistrationSeasonRegID",
            );
        },
        async getTerms() {
            return await this.$http.get("api/allStudents/getRegTerms");
        },
        onTermSelected(value) {
            this.regID = value;

            this.url = "tuitionDiscountRequests?regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        openCallbackRequestDialog() {
            this.callbackRequestDialog = true;
        },
        async save() {
            try {
                this.processing = true;

                if (
                    this.rowClicked.status == "COMPLETED" &&
                    !this.rowClicked.completedAt
                ) {
                    this.rowClicked.completedAt = moment().format(
                        "YYYY-MM-DD HH:mm:ss",
                    );
                    this.rowClicked.completedBy = this.$store.state.authentication.user;
                }

                if (this.rowClicked.status == "PENDING") {
                    this.rowClicked.completedAt = null;
                    this.rowClicked.completedBy = null;
                }

                await this.$http.post(
                    "api/tuitionDiscountRequests/save",
                    this.rowClicked,
                );

                this.processing = false;
                this.updateRequestDialog = false;

                this.$refs.grid.reloadGrid();

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        async moveToCallbackRequest() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/tuitionDiscountRequests/moveToCallBackRequest?id=" +
                        this.rowClicked.id,
                );

                this.processing = false;
                this.callbackRequestDialog = false;
                this.updateRequestDialog = false;

                this.$refs.grid.reloadGrid();

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.gray-fg {
    color: #999;
}
</style>
